import { flexibleUrlSchema } from "../url"
import z from "zod"

export const CompleteProfileFormSchema = z.object({
   id: z.string().uuid().optional(),
   firstName: z.string().min(2, { message: "First name must be at least 2 characters long" }).max(50),
   lastName: z
      .string()
      .min(2, { message: "Last name must be at least 2 characters long" })
      .max(50)
      .refine((val) => val !== "Placeholder", { message: "Please enter a valid last name" }),
   company: z.string().min(2, { message: "Company name must be at least 2 characters long" }).max(100),
   companyUrl: flexibleUrlSchema,
   phone: z.string().min(10, { message: "Phone number must be at least 10 characters long" }).max(15),
   position: z.string().min(2, { message: "Position must be at least 2 characters long" }).max(100),
   city: z.string().min(2, { message: "City must be at least 2 characters long" }).max(100),
   stateProvince: z.string().min(2, { message: "State/Province must be at least 2 characters long" }).max(100),
   companyOperations: z.string().min(2, { message: "Company operations must be at least 2 characters long" }).max(500),
   companyDescription: z
      .string()
      .min(2, { message: "Company description must be at least 2 characters long" })
      .max(1000),
   user_group_id: z
      .string()
      .min(2, { message: "User group ID must be at least 2 characters long" })
      .max(100)
      .optional(),
   email: z.string().email({ message: "Invalid email address" }).optional(),
})

export type CompleteProfileFormInputs = z.infer<typeof CompleteProfileFormSchema>
